export default {
  namespaced: true,
  state: {
    // * Permission data for external user
    token: null,
    tokenExpireAt: null,
    userRole: null,
    permissions: "",
    username: null,
    idcId: null,
    fullName: null,
    customerSitePermissions: null,

    // * Permission data for internal user
    internalToken: null,
    internalTokenExpireAt: null,
    internalUserRole: null,
    internalPermissions: "",
    internalUsername: null,
    internalFullName: null,
    internalSitePermissions: null,
    internalDepartmentPermissions: null,
    internalAllDepartment: null,
    internalAllSite: null,
  },
  getters: {
    // * Getters for external user
    getAccessToken(state) {
      return state.token
    },
    getAccessTokenExpire(state) {
      return state.tokenExpireAt
    },
    getUserRole(state) {
      return state.userRole
    },
    getUserPermission(state) {
      return state.permissions
    },
    getUserName(state) {
      return state.username
    },
    getIdcId(state) {
      return state.idcId
    },
    getFullName(state) {
      return state.fullName
    },
    getCustomerSitePermissions(state) {
      return JSON.parse(state.customerSitePermissions)
    },

    // * Getters for internal user
    getInternalAccessToken(state) {
      return state.internalToken
    },
    getInternalAccessTokenExpire(state) {
      return state.internalTokenExpireAt
    },
    getInternalUserRole(state) {
      return state.internalUserRole
    },
    getInternalUserPermission(state) {
      return state.internalPermissions
    },
    getInternalUserName(state) {
      return state.internalUsername
    },
    getInternalFullName(state) {
      return state.internalFullName
    },
    getInternalSitePermission(state) {
      return state.internalSitePermissions
    },
    getInternalDepartmentPermissions(state) {
      return state.internalDepartmentPermissions
    },
    getInternalAllSite(state) {
      return state.internalAllSite
    },
    getInternalAllDepartment(state) {
      return state.internalAllDepartment
    },
  },
  mutations: {
    // * Mutations for external user
    SET_ACCESS_TOKEN(state, value) {
      state.token = value
    },
    SET_ACCESS_TOKEN_EXPIRE_DATE(state, value) {
      state.tokenExpireAt = value
    },
    SET_USER_ROLE(state, value) {
      state.userRole = value
    },
    SET_USER_PERMISSIONS(state, value) {
      state.permissions = value
    },
    SET_USER_IDC_ID(state, id) {
      state.idcId = id
    },
    SET_USERNAME(state, username) {
      state.username = username
    },
    SET_USER_FULL_NAME(state, fullName) {
      state.fullName = fullName
    },
    SET_CUSTOMER_SITE_PERMISSIONS(state, sitePermissions) {
      state.customerSitePermissions = sitePermissions
    },

    // * Mutations for internal user
    SET_INTERNAL_ACCESS_TOKEN(state, value) {
      state.internalToken = value
    },
    SET_INTERNAL_ACCESS_TOKEN_EXPIRE_DATE(state, value) {
      state.internalTokenExpireAt = value
    },
    SET_INTERNAL_USER_ROLE(state, value) {
      state.internalUserRole = value
    },
    SET_INTERNAL_USER_PERMISSIONS(state, value) {
      state.internalPermissions = value
    },
    SET_INTERNAL_USERNAME(state, username) {
      state.internalUsername = username 
    },
    SET_INTERNAL_USER_FULL_NAME(state, fullName) {
      state.internalFullName = fullName
    },
    SET_INTERNAL_SITE_PERMISSIONS(state, siteList) {
      state.internalSitePermissions = siteList
    },
    SET_INTERNAL_DEPARTMENT_PERMISSIONS(state, departmentList) {
      state.internalDepartmentPermissions = departmentList
    },
    SET_INTERNAL_ALL_SITE(state, value) {
      state.internalAllSite = value
    },
    SET_INTERNAL_ALL_DEPARTMENT(state, value) {
      state.internalAllDepartment = value
    },
  },
  actions: {
    // * Actions for external user
    setAccessPermission({ commit }, permissionData) {
      commit("SET_ACCESS_TOKEN", permissionData.token)
      commit("SET_ACCESS_TOKEN_EXPIRE_DATE", permissionData.tokenExpireAt)
      commit("SET_USER_ROLE", permissionData.userRole)
      commit("SET_USER_PERMISSIONS", permissionData.permissions)
      commit("SET_USER_IDC_ID", permissionData.idcId)
      commit("SET_USERNAME", permissionData.username)
      commit("SET_USER_FULL_NAME", permissionData.fullName)
      commit("SET_CUSTOMER_SITE_PERMISSIONS", permissionData.sitePermissions)
    },
    saveAccessPermissionToLocalStorage(_, permissionData) {
      localStorage.setItem("access-token", permissionData.token)
      localStorage.setItem("token-expire", permissionData.tokenExpireAt)
      localStorage.setItem("user-role", permissionData.userRole)
      localStorage.setItem(
        "user-permissions",
        JSON.stringify(permissionData.permissions)
      )
      localStorage.setItem("username", permissionData.username)
      localStorage.setItem("idc-id", permissionData.idcId)
      localStorage.setItem("full-name", permissionData.fullName)
      localStorage.setItem(
        "customer-site-permissions",
        JSON.stringify(permissionData.sitePermissions)
      )
    },
    setAccessPermissionFromLocalStorage({ commit }) {
      const token = localStorage.getItem("access-token")
      if (token) commit("SET_ACCESS_TOKEN", token)
      const tokenExpireAt = localStorage.getItem("token-expire")
      if (tokenExpireAt) commit("SET_ACCESS_TOKEN_EXPIRE_DATE", tokenExpireAt)
      const userRole = localStorage.getItem("user-role")
      if (userRole) commit("SET_USER_ROLE", userRole)
      const userPermissions = localStorage.getItem("user-permissions")
      if (userPermissions) commit("SET_USER_PERMISSIONS", userPermissions)
      const idcId = localStorage.getItem("idc-id")
      if (idcId) commit("SET_USER_IDC_ID", idcId)
      const username = localStorage.getItem("username")
      if (username) commit("SET_USERNAME", username)
      const fullName = localStorage.getItem("full-name")
      if (fullName) commit("SET_USER_FULL_NAME", fullName)
      const customerSitePermissions = localStorage.getItem(
        "customer-site-permissions"
      )
      if (customerSitePermissions)
        commit("SET_CUSTOMER_SITE_PERMISSIONS", customerSitePermissions)
    },
    userLogout({ commit }) {
      localStorage.removeItem("access-token")
      commit("SET_ACCESS_TOKEN", null)
      localStorage.removeItem("token-expire")
      commit("SET_ACCESS_TOKEN_EXPIRE_DATE", null)
      localStorage.removeItem("user-role")
      commit("SET_USER_ROLE", null)
      localStorage.removeItem("user-permissions")
      commit("SET_USER_PERMISSIONS", "")
      localStorage.removeItem("username")
      commit("SET_USER_IDC_ID", null)
      localStorage.removeItem("idc-id")
      commit("SET_USERNAME", null)
      localStorage.removeItem("full-name")
      commit("SET_USER_FULL_NAME", null)
      localStorage.removeItem("customer-site-permissions")
      commit("SET_CUSTOMER_SITE_PERMISSIONS", null)
    },

    // * Actions for internal user
    setInternalAccessPermission({ commit }, permissionData) {
      commit("SET_INTERNAL_ACCESS_TOKEN", permissionData.token)
      commit(
        "SET_INTERNAL_ACCESS_TOKEN_EXPIRE_DATE",
        permissionData.tokenExpireAt
      )
      commit("SET_INTERNAL_USER_ROLE", permissionData.userRole)
      commit("SET_INTERNAL_USER_PERMISSIONS", permissionData.permissions)
      commit("SET_INTERNAL_USERNAME", permissionData.username)
      commit("SET_INTERNAL_SITE_PERMISSIONS", permissionData.sitePermissions)
    },
    saveInternalAccessPermissionToLocalStorage(_, permissionData) {
      localStorage.setItem("internal-access-token", permissionData.token)
      localStorage.setItem(
        "internal-token-expire",
        permissionData.tokenExpireAt
      )
      localStorage.setItem("internal-user-role", permissionData.userRole)
      localStorage.setItem(
        "internal-user-permissions",
        JSON.stringify(permissionData.permissions)
      )
      localStorage.setItem("internal-username", permissionData.username)
      localStorage.setItem("internal-full-name", permissionData.fullName)
      localStorage.setItem(
        "internal-site-permissions",
        JSON.stringify(permissionData.sitePermissions)
      )
      localStorage.setItem(
        "internal-department-permissions",
        JSON.stringify(permissionData.departmentPermissions)
      )
    },
    setInternalAccessPermissionFromLocalStorage({ commit }) {
      const token = localStorage.getItem("internal-access-token")
      if (token) commit("SET_INTERNAL_ACCESS_TOKEN", token)
      const tokenExpireAt = localStorage.getItem("internal-token-expire")
      if (tokenExpireAt)
        commit("SET_INTERNAL_ACCESS_TOKEN_EXPIRE_DATE", tokenExpireAt)
      const userRole = localStorage.getItem("internal-user-role")
      if (userRole) commit("SET_INTERNAL_USER_ROLE", userRole)
      const userPermissions = localStorage.getItem("internal-user-permissions")
      if (userPermissions)
        commit("SET_INTERNAL_USER_PERMISSIONS", userPermissions)
      const username = localStorage.getItem("internal-username")
      if (username) commit("SET_INTERNAL_USERNAME", username)
      const fullName = localStorage.getItem("internal-full-name")
      if (fullName) commit("SET_INTERNAL_USER_FULL_NAME", fullName)
      const sitePermissions = localStorage.getItem("internal-site-permissions")
      if (sitePermissions)
        commit("SET_INTERNAL_SITE_PERMISSIONS", sitePermissions)
      const departmentPermissions = localStorage.getItem(
        "internal-department-permissions"
      )
      if (departmentPermissions)
        commit("SET_INTERNAL_DEPARTMENT_PERMISSIONS", departmentPermissions)
    },
    internalLogout({ commit, dispatch }) {
      localStorage.removeItem("internal-access-token")
      commit("SET_INTERNAL_ACCESS_TOKEN", null)
      localStorage.removeItem("internal-token-expire")
      commit("SET_INTERNAL_ACCESS_TOKEN_EXPIRE_DATE", null)
      localStorage.removeItem("internal-user-role")
      commit("SET_INTERNAL_USER_ROLE", null)
      localStorage.removeItem("internal-user-permissions")
      commit("SET_INTERNAL_USER_PERMISSIONS", "")
      localStorage.removeItem("internal-username")
      commit("SET_INTERNAL_USERNAME", null)
      localStorage.removeItem("internal-full-name")
      commit("SET_INTERNAL_USER_FULL_NAME", null)
      localStorage.removeItem("internal-site-permissions")
      commit("SET_INTERNAL_SITE_PERMISSIONS", null)
      localStorage.removeItem("internal-department-permissions")
      commit("SET_INTERNAL_DEPARTMENT_PERMISSIONS", null)
      commit("SET_INTERNAL_ALL_SITE", null)
      localStorage.removeItem("current-veeam-server")
      sessionStorage.removeItem("current-veeam-server")
      localStorage.removeItem("internal-site-select")
    },
    setInternalAllSite({ commit }, siteList) {
      commit("SET_INTERNAL_ALL_SITE", siteList)
    },
    setInternalAllDepartment({ commit }, departmentList) {
      commit("SET_INTERNAL_ALL_DEPARTMENT", departmentList)
    },
    setInternalSitePermission({ commit }, sitePermissions) {
      localStorage.setItem(
        "internal-site-permissions",
        JSON.stringify(sitePermissions)
      )
      commit("SET_INTERNAL_SITE_PERMISSIONS", sitePermissions)
    },
    setInternalFullName({ commit }, fullName) {
      localStorage.setItem("internal-full-name", fullName)
      commit("SET_INTERNAL_USER_FULL_NAME", fullName)
    },
  },
}
